module.exports = __webpack_public_path__ + "img/amnesty.3b0fad7.png";